import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=3d8a08e2&scoped=true"
import script from "./exhibition.vue?vue&type=script&setup=true&lang=js"
export * from "./exhibition.vue?vue&type=script&setup=true&lang=js"
import style0 from "./exhibition.vue?vue&type=style&index=0&id=3d8a08e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a08e2",
  null
  
)

export default component.exports